import $ from "jquery";

import model from "js/models/questions";
import tmpl from "js/templates/steps";
import QuestionView from "js/views/questions";
import { QUESTION_TYPE } from "lib/constants";

import { BaseStep as Step } from "./base";

function isQuestionsTest() {
    return false;
    // const uid = (window.heap && window.heap.identity) || cookie.get('_ws_heap') || window.uid;
    // return Number(uid) % 2 === 0 && Number(uid) >= 144360;
}

const QuestionsStep = Step.extend({
    name: "STEP_QUESTIONS",
    template: false,
    companies: [],
    postInit() {
        let questions = new model.Questions(this.model.get("_questions") || window.questions);
        questions = questions.filter((q) => !q.isSkill());

        this.questions = questions.map(
            (mod) =>
                new QuestionView({
                    model: mod,
                    hideClean: this.shouldHideClean(),
                }),
        );

        this.reviewing = this.options.isProfile || this.options.isReview;
    },
    shouldHideClean() {
        return !this.options.isProfile && !this.options.isReview;
    },
    shouldSkip() {
        /* eslint-disable no-return-assign */
        const visibleCount = this.questions.reduce((s, q) => (s += q.isHidden() ? 0 : 1), 0);
        /* eslint-enable no-return-assign */
        return visibleCount < 1;
    },
    ui: {
        radios: "input[type=radio]",
    },
    events: {
        "click @ui.radios": "toggleFollowUp",
    },

    renderQuestionCards() {
        const questions = window.questions
            .filter((q) => q.type !== QUESTION_TYPE.SELECT_ONE)
            .filter((q) => {
                const { response, reprompt_threshold: threshold } = q;

                // Check if we need to reprompt first
                if (threshold && new Date(threshold) <= new Date()) {
                    const reprompt = q.reprompt_answers;
                    if (reprompt && reprompt.indexOf(response) > -1) {
                        return true;
                    }
                }

                // If they haven't responded yet
                if (!response || (Array.isArray(response) && response.length === 0)) {
                    return true;
                }

                const answer = q.answer.filter((a) => a.has_follow_up);
                const followUp = answer.length ? answer[0].id : null;

                // If they haven't give us a proper follow-up yet
                if (followUp && response === followUp && !q.follow_up_response) {
                    return true;
                }

                // Otherwise they've already answered, good job buddy
                return false;
            })
            // React code expects response to be a full answer dict
            .map((q) => ({
                ...q,
                response: q.answer_dict,
            }));

        // We mount outside the app container because otherwise
        $("#app-container").hide();

        const unmount = window.wsjs.candidate.init("APPLICATION_QUESTIONS", {
            state: {
                questions: {
                    questions,
                },
            },
            props: {
                forSuggestions: window.hasSuggestions && !this.reviewing,
                handleCompleted: () => {
                    unmount();

                    setTimeout(() => {
                        window.location.reload();
                    }, 0);

                    /* If the test wins we can actually use the
                       stuff below probably with a few minor tweaks */
                    // const data = completedQuestions.map((q) => {
                    //     const response = { ...q.response };
                    //     delete response.id;
                    //
                    //     return {
                    //         ...q,
                    //         ...response,
                    //     };
                    // });
                    //
                    // this.model.set({ _questions: data }, { validate: 'partial' });
                    //
                    // unmount();
                    // this.nextStep();
                    // $('#app-container').fadeIn();
                },
            },
        });
    },

    render() {
        if (isQuestionsTest() && !this.reviewing) {
            this.renderQuestionCards();
        } else {
            let html = "<h2>Company Questions</h2>";
            if (window.hasSuggestions && !this.reviewing) {
                html += '<p class="app-suggested-questions">';
                html += "A few additional questions from the jobs you just selected</p>";
            }

            let companyName = "";
            this.questions.forEach((view) => {
                if (!view.isHidden() && view.companyName() !== companyName) {
                    companyName = view.companyName();
                    html += tmpl.Company({ name: companyName });
                }
                html += view.render().el.innerHTML;
            });

            this.attachElContent(html);
        }

        this.onRender();
        return this;
    },
    postRender() {
        if (isQuestionsTest()) {
            $(".next-container").hide();
        }
    },
    postNext() {
        if (isQuestionsTest()) {
            $(".next-container").show();
        }
    },
    toggleFollowUp(e) {
        const $e = $(e.target);
        const $div = $e.siblings(".follow-up");

        if ($e.hasClass("has-follow-up")) {
            $div.fadeIn();
        } else {
            $div.fadeOut();
        }
    },
    submit() {
        let data = [];

        this.questions.forEach((view) => {
            const viewData = view.getData();
            data = data.concat(viewData);
        });

        const clean = data.reduce((s, n) => (s ? n.clean : false), true);

        if (clean) {
            this.model.set({ _questions: data }, { validate: "partial" });
            return true;
        }
        return false;
    },
});

export default QuestionsStep;
